import urlConfig from '@/config'

export function littleGenius ({ mobile, grade, subject }) {
  const commodityType = subject === '语文素养' ? '4' : '1'
  const level = grade
  window.location.href = `${urlConfig.aiH5PageURL}?commodityType=${commodityType}&channelId=17783&mobile=${mobile}&platform=mobile&level=${level}`
}